import { render } from "./FormCheckBox.vue?vue&type=template&id=1fef983f&scoped=true"
import script from "./FormCheckBox.vue?vue&type=script&lang=js"
export * from "./FormCheckBox.vue?vue&type=script&lang=js"

import "./FormCheckBox.vue?vue&type=style&index=0&id=1fef983f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fef983f"]])

export default __exports__